import CreateHistory from 'history/createBrowserHistory';
const history = CreateHistory();
export default history;



// WEBPACK FOOTER //
// ./src/libraries/History.js